import {
  ISbRichtext,
  renderRichText,
  SbBlokData,
  StoryblokComponent,
  storyblokEditable,
} from '@storyblok/react';
import cx from 'classnames';
import React from 'react';
import parse from 'html-react-parser';

import PageContainer from '@/components/PageContainer/PageContainer';
import priceOfferRichTextSchema from './richTextSchema';

export interface PriceOfferSectionBlokProps extends SbBlokData {
  content: ISbRichtext;
  cta: Array<SbBlokData>;
  title: ISbRichtext;
  topic: string;
  id?: string;
  visibility?: 'enabled' | 'disabled';
  visibilityOnMobile?: 'enabled' | 'disabled';
}

export interface PriceOfferSectionProps {
  blok: PriceOfferSectionBlokProps;
}

const PriceOfferSection = ({ blok }: PriceOfferSectionProps) => {
  const {
    content,
    cta: [ctaButton] = [],
    id,
    visibility = 'enabled',
    visibilityOnMobile = 'enabled',
    title,
    topic,
  } = blok;

  if (visibility === 'disabled') {
    return null;
  }

  return (
    <section
      {...storyblokEditable(blok)}
      className={cx('w-full bg-white', {
        'hidden sm:block': visibilityOnMobile === 'disabled',
      })}
      id={id}
    >
      <PageContainer className="!pt-0 !pb-6">
        <div className="bg-GSblue/500 w-full flex flex-col px-6 py-14 items-stretch sm:items-center gap-y-14 rounded-lg text-GSbase/white">
          <div className="flex flex-col gap-6 sm:gap-2 items-start sm:items-center">
            <div className="font-raleway text-sm leading-6 tracking-[2px]">
              {topic}
            </div>
            <div className="flex flex-col gap-4 items-center">
              <div className="text-[28px] leading-10 sm:text-4xl sm:leading-[56px] font-bold font-raleway">
                {parse(
                  renderRichText(title, {
                    schema: priceOfferRichTextSchema,
                  }),
                )}
              </div>
              <div className="font-worksans font-medium sm:font-normal text-lg leading-7">
                {parse(
                  renderRichText(content, {
                    schema: priceOfferRichTextSchema,
                  }),
                )}
              </div>
            </div>
          </div>
          {ctaButton && (
            <div>
              <StoryblokComponent
                blok={ctaButton}
                type="secondary"
                size="btn-LG"
              />
            </div>
          )}
        </div>
      </PageContainer>
    </section>
  );
};

export default PriceOfferSection;
